import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React, { useRef, useCallback, useState } from 'react';
import isFunction from "lodash/isFunction";
export function bindActionCreators(dispatch, actions = {}) {
  var _context;
  return _reduceInstanceProperty(_context = _Object$entries(actions)).call(_context, (acc, [name, action]) => _objectSpread({}, acc, {
    [name]: (...args) => dispatch(action(...args))
  }), {});
}
export function useControlledReducer({
  reducer,
  initialState,
  controlledState,
  onStateChange,
  updateInControlledMode = false
}) {
  const store = useRef({
    state: initialState
  }).current;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    setState = _useState2[1];
  const update = useCallback(() => setState(state => state + 1), []);
  if (controlledState !== undefined) {
    store.state = isFunction(controlledState) ? controlledState(store.state) : controlledState;
  }
  store.reducer = reducer;
  store.dispatch = action => {
    const oldState = store.state;
    const newState = store.reducer(oldState, action);
    if (newState === oldState) {
      return;
    }
    if (onStateChange) {
      onStateChange(newState);
    }
    if (!controlledState || updateInControlledMode) {
      store.state = newState;
      update();
    }
  };
  const dispatch = useCallback(action => store.dispatch(action), [store]);
  return [store.state, dispatch];
}